<template>
  <tr>
    <td class="has-text-centered">
      <ProductPhoto :type="product.type" :photos="product.photos" />
    </td>
    <td class="has-text-centered" style="maxWidth: 250px">
      <router-link
        :to="{ name: 'products.edit', params: { uuid: product.uuid } }"
      >
        {{ product.title }}
      </router-link>
      <p v-for="(barcode, index) in product.barcodes" :key="index">
        {{ barcode.code }}
      </p>
    </td>
    <td class="has-text-centered">{{ product.stock }}</td>
    <td class="has-text-centered">{{ product.sell_price }}</td>
    <td class="has-text-centered">{{ product.discount }}</td>
    <td class="has-text-centered">{{ product.final_price }}</td>
    <td class="has-text-centered">{{ product.tax.percentage }}</td>
    <td class="has-text-centered">
      <span v-if="product.available_forever" class="tag is-success">Ναι</span>
      <span v-else class="tag is-danger">Όχι</span>
    </td>
    <td v-if="isEditing" class="has-text-centered hidden-print">
      <button class="button is-small" @click="handleDeleteItem">
        <span class="icon is-small">
          <span class="fa fa-fw fa-trash-o" />
        </span>
      </button>
    </td>
  </tr>
</template>

<script>
import ProductPhoto from '@/views/components/ProductPhoto';

export default {
  components: {
    ProductPhoto,
  },
  props: {
    product: Object,
    index: Number,
    isEditing: Boolean,
  },
  methods: {
    handleDeleteItem() {
      this.$emit('delete-item', this.product);
    },
  },
};
</script>
